export const ROOT_DIR = 'http://' + window.location.host;

export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const PAGES = [
  {
    "name": "What and Where",
    "link": "/about"
  },
  {
    "name": "Upcoming Gigs",
    "link": "/gigs"
  },
  {
    "name": "Video",
    "link": "/video"
  },
  {
    "name": "Photos",
    "link": "/photos"
  },
  {
    "name": "contact",
    "link": "/contact"
  }
]


// WEBPACK FOOTER //
// ./src/utils/Constants.js